import angular from 'angular';
import {shopModule} from '../../module.js';

shopModule.directive('ns-html-title', ['$sanitize', function($sanitize) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            attrs.$observe('ns-html-title', function (title) {
                let html = angular.element('<div></div>').html($sanitize(title)).text();
                element.attr('title', html);
            });
        }
    }
}]);
